import Dropdown from './dropdown';
import DropdownMenu from './dropdown-menu';
import DropdownItem from './dropdown-item';

Dropdown.DropdownMenu = DropdownMenu;
Dropdown.DropdownItem = DropdownItem;

export default Dropdown;
